var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.13997C6.83367 8.13997 5.1 6.43147 5.1 4.36998C5.1 2.3085 6.83367 0.6 9 0.6C11.1663 0.6 12.9 2.3085 12.9 4.36998C12.9 6.43147 11.1663 8.13997 9 8.13997ZM17.399 17.3495C16.9711 18.2324 16.2305 18.927 15.3186 19.2968L14.4219 19.6604C10.8923 20.7688 7.10774 20.7688 3.57814 19.6604L2.68137 19.2968C1.76947 18.927 1.02887 18.2323 0.601001 17.3495C0.627294 15.6346 1.17085 13.9267 2.12413 12.6504C3.085 11.3639 4.44682 10.5291 6.13395 10.5136L6.78444 10.621C8.25155 10.8633 9.74845 10.8633 11.2156 10.621L11.866 10.5136C13.5527 10.5291 14.9145 11.3638 15.8755 12.6504C16.8289 13.9268 17.3727 15.6346 17.399 17.3495Z",
    stroke: "current",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.fc536b3584eeae168624e2dac671eeeb.svg";
export { ForwardRef as ReactComponent };